module.exports = __webpack_public_path__ + "static/img/left-arrow-black-triangle.32f7d25.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/left-arrow-black-triangle.png
// module id = N2eO
// module chunks = 1